import React from "react";

import { useGetFormattedEmployeeDataQuery, useGetCurrentCompanyApplicationQuery, useGetCompanyContributionsQuery } from "EmployerApplication/api";
import AnalyticsTracking from "Utils/AnalyticsTracking";

import EditEmployeePriceBreakdownBody from "../EditEmployeePriceBreakdown/EditEmployeePriceBreakdownBody";
import { TitleSmall } from "Cobalt/Header";
import { StandaloneTrigger, Modal, ModalBody, ModalHeader } from "Cobalt/Modal";
import Button from "Common/Button";
import { CONTRIBUTION_TYPES } from "Common/Constants";

const ComprehensiveCostEstimationModal = ({ medicalPlans, triggerText, useGrayButtonTrigger }) => {
  const { refetch: refetchFormattedEmployeeData } = useGetFormattedEmployeeDataQuery();
  const { data: companyApplication } = useGetCurrentCompanyApplicationQuery();
  const companyPolicyId = companyApplication?.id;
  const { data: companyContributions } = useGetCompanyContributionsQuery(companyPolicyId, { skip: !companyPolicyId });

  const defaultContribution = {
    employeePercentage: "50",
    dependentPercentage: "0",
    employeeFixedAmount: null,
    dependentFixedAmount: null,
  };

  const contributionType = CONTRIBUTION_TYPES[companyApplication?.typeOfContribution] || CONTRIBUTION_TYPES.percentage;
  const contributions = companyContributions?.length ? companyContributions.filter((contribution) => contribution.active) : [defaultContribution];

  return (
    <StandaloneTrigger
      trigger={(props) =>
        React.createElement(
          useGrayButtonTrigger ? Button : "a",
          {
            color: "gray",
            href: "#",
            onClick: (e) => {
              props.onClick(e);
              refetchFormattedEmployeeData();
              AnalyticsTracking.trackEvent("employee_costs_viewed", {
                location: "cart_page",
                medicalPlans,
                contributionType,
                contributions,
              });
            },
            style: { width: "100%" },
            ...props,
          },

          triggerText || "View Cost Breakdown",
        )
      }
      modal={(props) => (
        <Modal className="modal-xl" {...props}>
          <ModalHeader closeButton>
            <TitleSmall mb={0} mt={0}>
              Explain This Price
            </TitleSmall>
          </ModalHeader>
          <ModalBody>
            <EditEmployeePriceBreakdownBody contributionType={contributionType} contributions={contributions} />
          </ModalBody>
        </Modal>
      )}
    />
  );
};

export default ComprehensiveCostEstimationModal;
